import React from 'react'
import { getConfig } from '../../../../config'
import { allInstalls, InstallType, useFirstEligibleInstall } from '../../../../lib/hooks/install-eligibility'
import { withPublicAssetUrl } from '../../../../lib/utils/cdn'
import { UnsupportedButton } from '../unsupported'
import { KeyboardInstallButtonCtaProps } from './base'
import { DeviceSpecificKeyboardInstallButtonBase } from './device-specific'

const { ios, ipad } = getConfig().products.keyboard

const buttonImg = withPublicAssetUrl('./app-store/iOS-app-store.svg')

export const IPadInstallButton: React.FC<KeyboardInstallButtonCtaProps> = (props) => {
  return (
    <DeviceSpecificKeyboardInstallButtonBase
      {...props}
      buttonImg={buttonImg}
      installUrl={ipad}
      install={InstallType.IPad}
    />
  )
}

export const IPhoneInstallButton: React.FC<KeyboardInstallButtonCtaProps> = (props) => {
  return (
    <DeviceSpecificKeyboardInstallButtonBase
      {...props}
      buttonImg={buttonImg}
      installUrl={ios}
      install={InstallType.IPhone}
    />
  )
}

export const IOSInstallButton: React.FC<KeyboardInstallButtonCtaProps> = (props) => {
  const preferredInstall = useFirstEligibleInstall([InstallType.IPad, InstallType.IPhone])
  switch (preferredInstall) {
    case InstallType.IPad:
      return <IPadInstallButton {...props} />
    case InstallType.IPhone:
      return <IPhoneInstallButton {...props} />
    default:
      return <UnsupportedButton alternateLinkInstallTypes={allInstalls} {...props} />
  }
}
